import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, OnChanges, OnDestroy, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { AuthService } from '../../../services/auth/auth.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';

import { ArangoService } from '../../../services/arangoservice/arango.service';
import { firstValueFrom, Observable, of, Subscription } from 'rxjs';
import { Person, getPurchaseList, getUserName } from '../../../bo9-shared/models/person/person.model';

import { userIsAdmin } from '../../../bo9-shared/models/person/BO9rolesmethods.model';

import { EventAttendee } from '../../../bo9-shared/models/event/event.model';
import { MatTableDataSource } from '@angular/material/table';


@Component({
    selector: 'dupemail-list',
    templateUrl: './dupEmailList.component.html',
    styleUrls: ['./dupEmailList.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DupEmailList implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @Input() attendees: EventAttendee[];
  @Input() emailList: number[] | null;
  @Input() canAll: boolean;
  @Output() notifyParent: EventEmitter<number> = new EventEmitter <number>;

  public colList =   ['select','name','email'];
  valid: false;

  user: Person;
  person: Person;

  public dataSource = new MatTableDataSource<EventAttendee>();

  
  subscriptions: Subscription[] = [];
  constructor(
    private router: Router,
    private arangoService: ArangoService,
    private auth: AuthService,

    )
  {

   this.user = this.auth.getAuthUser()!;
   this.subscriptions.push(this.arangoService.recordVisit({
     page: this.router.url, component: 'DupEmailList', 
     visitor: this.user._key,
     help: false
   }).subscribe({
     next: () => {
     
     
     }
   })); 
   
  }


  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }


  ngOnChanges() {
    if (this.emailList) {
      for (let i = 0; i < this.emailList.length; i++) {
        this.dataSource.data.push(this.attendees[this.emailList[i]]);
      }
    }
    console.log("Email list" + this.emailList)
  }



  ngAfterViewInit(): void {
   
  }


  

  isAdmin(): boolean {
    return(userIsAdmin(this.user));
  }

  onClickSelect(index: number) {
    if (this.emailList) {
          if (confirm("Clean Emails?")) {
      if (this.notifyParent) { this.notifyParent.emit(this.emailList[index]); }
    }
    }


  }
  

  ngOnInit() {


  }


}
